import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import Close from './Close';
import { Badge } from '../../Badge';
import Icon from '../../Icon';
import { ImageFit } from '../../Image';
import { Button } from '../../Button';
import color from '../../../theme/color';
import routes from '../../../../conf/routes';

import {
  Container,
  ImageContainer,
  Logo,
  Image,
  Content,
  BadgeWrapper,
  HoursWrapper,
  Hours,
  CollectionWrapper,
  IconWrapper,
  Number
} from './styles';

const IconCenter = styled(Icon)`
  position: relative;
  display: inline-block;
  top: 50%;
  transform: translateY(-50%);
`;

const DetailButton = styled(Button)`
  min-width: 0;
`;

class Detail extends Component {
  render() {
    const { data, t, i18n, handleOpenCloseDetail, isOpen } = this.props;
    return (
      <Container isOpen={isOpen}>
        <Close onClick={() => handleOpenCloseDetail(false)} />
        <ImageContainer>
          {data.imgDesk && data.logo2Desk ? (
            <div>
              <Logo src={data.logo2Desk} />
              <ImageFit src={data.imgDesk} />
            </div>
          ) : data.imgDesk && !data.logo2Desk ? (
            <ImageFit src={data.imgDesk} />
          ) : (
            <Image src={'/static/images/logo-192.png'} />
          )}
        </ImageContainer>
        <Content>
          <BadgeWrapper>
            <Badge hours={data.hours ? JSON.parse(data.hours) : null} />
          </BadgeWrapper>
          {data.ttText && (
            <HoursWrapper>
              <Hours dangerouslySetInnerHTML={{ __html: data.ttText }} />
            </HoursWrapper>
          )}
          {!data.ttText &&
            data.type &&
            data.type.includes('[/blocktext') && (
              <HoursWrapper>
                <Hours
                  dangerouslySetInnerHTML={{
                    __html: data.type
                      .split('[/')[1]
                      .replace('blocktext=', '')
                      .replace('/]', '')
                  }}
                />
              </HoursWrapper>
            )}
          {data.phone && (
            <CollectionWrapper href={`tel:${data.phone}`}>
              <IconWrapper>
                <IconCenter color={color.secondary} name="telephone" />
              </IconWrapper>
              <Number>{data.phone}</Number>
            </CollectionWrapper>
          )}
          {data.slug &&
            (data.type ? (
              data.type.includes('[/blocktext') ? (
                <DetailButton
                  href={`/${
                    routes.generic.langs[i18n.language].split('/')[0]
                  }/${data.slug}/`}
                >
                  {t('common:plan.panel.button').toUpperCase()}
                </DetailButton>
              ) : (
                <DetailButton
                  href={`/${t('common:brands.navigation.brands')}/${data.slug}`}
                >
                  {t('common:plan.panel.button').toUpperCase()}
                </DetailButton>
              )
            ) : (
              <DetailButton
                href={`/${t('common:brands.navigation.brands')}/${data.slug}`}
              >
                {t('common:plan.panel.button').toUpperCase()}
              </DetailButton>
            ))}
        </Content>
      </Container>
    );
  }
}

Detail.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object.isRequired,
  handleOpenCloseDetail: PropTypes.func.isRequired
};

export default translate()(Detail);
